import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DropdownComponent } from './dropdown.component';

@Injectable({
  providedIn: 'root',
})
export class DropdownService {
  opened: Subject<DropdownComponent>;

  constructor() {
    this.opened = new Subject();
  }

  emitOpenEvent(dropdown: DropdownComponent) {
    this.opened.next(dropdown);
  }
}
